/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LibModelsFuelTankLevel
 */
export interface LibModelsFuelTankLevel {
    /**
     * 
     * @type {Date}
     * @memberof LibModelsFuelTankLevel
     */
    time: Date;
    /**
     * 
     * @type {number}
     * @memberof LibModelsFuelTankLevel
     */
    level?: number;
}

export function LibModelsFuelTankLevelFromJSON(json: any): LibModelsFuelTankLevel {
    return LibModelsFuelTankLevelFromJSONTyped(json, false);
}

export function LibModelsFuelTankLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): LibModelsFuelTankLevel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'time': (new Date(json['time'])),
        'level': !exists(json, 'level') ? undefined : json['level'],
    };
}

export function LibModelsFuelTankLevelToJSON(value?: LibModelsFuelTankLevel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'time': (value.time.toISOString()),
        'level': value.level,
    };
}


